<template>

  <section  class="navbarsection" style="margin-top: -50px;">
    <div class="txtdata">
      <h1  style="padding-top: 200px;"></h1>
    </div>
      <div class="videosection" >
        <div  v-show="pvisvideo === true && pvpictureimage === false ">
          <Transition class="transition thing">
            <video-background 
              playbackRate=0.98
              :src="src"
              :poster="poster"
              :class="`thing playercss`"
              :style="`height: 600px;`">
            </video-background>
          </Transition>
        </div>
      
          <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
          </div>

          <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
          v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
 
    </div>
    <div class="overlay"></div>
    <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
      <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
    </div>
  </section>


    <section style="margin-top: 150px;">
      <DataleftCardright :aboutgovern="aboutgovern" />
    </section>



    <div class="datapdfmandate">
    <DownloadPdf :tabledata="corpgovernmandate" :opssection1="chartermandate" />
  </div>



  <div class="datapdfguideline">
    <DownloadPdf :tabledata="corpgovernpolicy" :opssection1="policyguideline" />
  </div>



  <section class="settingpadding">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 formatleft">
        <div v-html="compliantsprocess"></div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 formatright">
        <img :src="`${cpimg}`" class="imgformat" />
      </div>
    </div>
  </section>

  <section class="lastsection">
    <span v-html="aboutgeneral.pdesc" class="hrspantext"></span>
  </section>

  <!-- <ModalDisplay /> -->
</template>

<script>

import LeadershipCards from '@/components/LeadershipCards.vue';
import DataleftCardright from '@/components/DataleftCardright.vue'
import DownloadPdf from '@/components/DownloadPdf.vue'
require('@/globalDeclare.js');
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
// require('@/setup.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
 LeadershipCards, DataleftCardright, DownloadPdf
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  pictureimage: '',
  picurl: myUrlPath,

 
  aboutgeneral: [],
  showImage: false,
  publicPath: window.location.origin,

  cmimage1: [],
  cmimage2: '',
  cmimage3: '',
  myPicUrl: '',

  aboutgovern: '',
  chartermandate: '',
  policyguideline: '',
  compliantsprocess: '',
  cpimg: '',
  aboutgeneral: [],
  tableshow: false,
  rightimage: '',

  breadcrumbsinfo: [],

  corpgovernmandate: [],
  corpgovernpolicy: [],

  opssection1: '',

  tabledata: []

  }
},

mounted() {
  let showImage = Boolean
  showImage = false
  this.myPicUrl = myUrlPath

//change the page name and the top panorama or video will take effect.
axios.get('allpagespv/governance').then(
  response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

       if (this.pvisvideo === true) {
          this.src = this.videoimage.pvsrc
        }
        else {
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -20.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.7,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
        }
      })
      .catch((error) => {
          console.log(error)
        })
        
  //------------corpgovernance info---------------
  axios.get('getcorpgovernanceinfo/').then(
    response => {
        this.aboutgovern = response.data
        this.chartermandate = response.data.chartermandate
        this.policyguideline = response.data.policyguideline
        this.compliantsprocess = response.data.compliantsprocess
        this.cpimg =  response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------mandate table info---------------
  axios.get('getcorpgovernmandateinfo/governance').then(
  response => {
        this.corpgovernmandate = response.data
  })
  .catch((error) => {
      console.log(error)
    })


  //------------corpgovernpolicy table info---------------
  axios.get('getcorpgovernpolicyinfo/governance').then(
    response => {
        this.corpgovernpolicy = response.data
  })
  .catch((error) => {
      console.log(error)
    })


  //general page information
axios.get('aboutpagegeneral/governance').then(
    response => {
        this.aboutgeneral = response.data
  })
  .catch((error) => {
      console.log(error)
    })



//------------mandate table info---------------
axios.get('getuploadededfile/governance').then(
    response => {
        this.tabledata = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Operations products page Cards ---------------
axios.get('getopspageexploration/').then(
    response => { 
    this.opssection1 = response.data[0].opssection1
    console.log(this.opssection1)
  })
  .catch((error) => {
      console.log(error)
    }) 

//------------breadcrumbs mappings info---------------
  axios.get('getbreadcrumbsinfo/governance').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })  
      
}
}


</script>

<style lang="scss" scoped>
@import "@/assets/scss/vendors/bootstrap-vue/_custom.scss";


.topdiv {
  width: 100%;
}
.middlediv {
  width: 100%;
}

.txtright {
  text-align: right;
}

.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.hrspantext {
  padding-top: 10px;
}
.imageswidth {
  max-width: 100%;
}

.TextleftDivcss {
  width: 100%;
}
.TextleftDivcss1 {
  color: grey;
  height: auto;
}
.txtoutmdesc {
  margin: 0 auto;
  margin-top: 30px;
  font-size: 26px;
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-weight: bold;
}



 //formatting
.dataleftrightcss {
  width: 80%;
  margin: 0 auto;
}
.datapdfmandate {
  margin-top: 30px;
}
.datapdfguideline {
  margin-top: 30px;
}
.imgformat{
  width: 100%;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
 .dataleftsection {
  margin-top: -50px;
 }



  
  .datapdfmandate {
    margin-top: 30px;
  }
  .datapdfguideline {
    margin-top: 30px;

  }
  
  .lastsection {
    margin-top: 30px;
  }

  .settingpadding {
    padding: 30px;
    margin-top: 60px;
  }
  
}

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {


    .datapdfmandate {
      margin-top: 40px;
      padding: 40px;
    }
    .datapdfguideline {
      margin-top: 40px;
  
    }
  
    .lastsection {
      margin-top: 30px;
    }

  .settingpadding {
    padding: 60px;
    margin-top: 60px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {

  
  .datapdfmandate {
    margin-top: 30px;
  }
  .datapdfguideline {
    margin-top: 100px;

  }

 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {


    .datapdfmandate {
      margin-top: 30px;
    }
    .datapdfguideline {
      margin-top: 30px;
  
    }
 

 }

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only  screen and (min-width: 1200px){

  .datapdfmandate {
    margin-top: 30px;
  }
  .datapdfguideline {
    margin-top: 30px;

  }
  .datapdfcompliance {
    margin-top: 30px;
  }
 } 

 @media only  screen and (min-width: 1400px) {
    .datapdfmandate {
      margin-top: 30px;
      background-color: aliceblue;
      padding-top: 40px;
      padding-bottom: 40px;
    }
    .datapdfguideline {
      margin-top: 30px;
  
    }
    .datapdfcompliance {
      background-color: antiquewhite;
      padding-bottom: 40px;
    }

    .settingpadding{
      padding-left: 200px;
      padding-right: 200px;
      padding-bottom: 100px;
      padding-top: 100px;
    }
 }
</style>

